import React, { useState } from "react";
import Label from "../../../components/UI/Label";
import { Formik, Field, Form } from "formik";
import { PrimaryButton } from "../../../components/UI";
import { NewTealiumAudienceIntegrationFormSchema } from "../../../schemas";
// import { useUserContext } from "../../Contexts/UserContext";
import Loader from "../../UI/Loader/Loader";
import SuccessAlert from "../../../components/UI/Alert/SuccessAlert";
import ErrorAlert from "../../../components/UI/Alert/ErrorAlert";
import { useNavigate } from "react-router-dom";
import backwardArrow from "../../../assets/icons/backward-arrow.svg";
import Tooltip from "../../../components/UI/Tooltip";
import { useContentfulContext } from "../../../contexts/ContentfulContext";

const NewTealiumAudienceStream = () => {
  // const { userData } = useUserContext();
  const { content } = useContentfulContext();

  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values, actions) => {
    try {
      setLoading(true);

      // const data = {
      //   tealium_as_audience_id: values.tealium_as_audience_id,
      //   tealium_as_audience_name: values.tealium_as_audience_name,
      //   at_audience_id: values.at_audience_id,
      //   at_audience_name: values.at_audience_name,
      //   at_audience_workspace: values.at_audience_workspace,
      // };

      // await addNewTealiumProduct(userData.token, {
      //   organizationId: userData.selectedOrganization.org_token,
      //   data,
      // });
      !loading && setShowSuccess(true);
      // setTealiumIntegration();
      setTimeout(() => {
        navigate("/audience/tealium-api-key-integrations");
      }, 1000);
    } catch (error) {
      setShowError(error?.message || "default error");
      setTimeout(() => {
        setShowError("");
      }, content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.timeout);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full px-4 md:px-8 my-6">
      {loading && <Loader />}
      {showSuccess && (
        <SuccessAlert
          disappearTime={content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.timeout}
        >
          {content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.success}
        </SuccessAlert>
      )}
      {showError && (
        <ErrorAlert timeout={content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.timeout}>
          {showError}
        </ErrorAlert>
      )}
      <div className="flex flex-col lg:w-1/2 justify-center items-start">
        <div className="space-y-4 md:space-y-6 w-full">
          <p
            className="font-medium cursor-pointer text-primary hover:underline flex items-center"
            onClick={(e) => {
              e.preventDefault();
              navigate("/audiences/tealium-audience-stream");
            }}
          >
            <img src={backwardArrow} alt="" className="w-5 h-5 mr-2" />{" "}
            {content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.back_cta_text}
          </p>
          <Formik
            initialValues={{
              tealium_as_audience_id: "",
              tealium_as_audience_name: "",
              at_audience_id: "",
              at_audience_name: "",
              at_audience_workspace: "",
            }}
            validationSchema={() => NewTealiumAudienceIntegrationFormSchema(content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM)}
            onSubmit={handleSubmit}
          >
            {({ errors, touched, setFieldValue }) => (
              <Form action="#">
                <h2 className="text-xl font-bold leading-tight tracking-tight text-black text-left mb-4">
                  {content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.title}
                </h2>
                <p>{content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.description}</p>
                <div className="my-4">
                  <div className="relative">
                    <Field
                      type="text"
                      id="tealium_as_audience_id"
                      name="tealium_as_audience_id"
                      class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                      placeholder=" "
                    />
                    <Label labelFor="tealium_as_audience_id">
                      {
                        content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.formLabels
                          .tealium_as_audience_id
                      }
                    </Label>
                    <Tooltip
                      content={
                        content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.help_text
                          .tealium_as_audience_id
                      }
                      class_name="-right-8 top-1/2"
                    />
                  </div>
                  {errors.tealium_as_audience_id && touched.tealium_as_audience_id ? (
                    <p className="mt-2 text-sm text-red-5">
                      {errors.tealium_as_audience_id}
                    </p>
                  ) : null}
                </div>
                <div className="mb-4">
                  <div className="relative">
                    <Field
                      type="text"
                      id="tealium_as_audience_name"
                      name="tealium_as_audience_name"
                      class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                      placeholder=" "
                    />
                    <Label labelFor="tealium_as_audience_name">
                      {
                        content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.formLabels
                          .tealium_as_audience_name
                      }
                    </Label>
                    <Tooltip
                      content={
                        content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.help_text
                          .tealium_as_audience_name
                      }
                      class_name="-right-8 top-1/2"
                    />
                  </div>
                  {errors.tealium_as_audience_name && touched.tealium_as_audience_name ? (
                    <p className="mt-2 text-sm text-red-5">
                      {errors.tealium_as_audience_name}
                    </p>
                  ) : null}
                </div>
                <div className="mb-4">
                  <div className="relative">
                    <Field
                      type="text"
                      id="at_audience_id"
                      name="at_audience_id"
                      class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                      placeholder=" "
                    />
                    <Label labelFor="at_audience_id">
                      {
                        content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.formLabels
                          .at_audience_id
                      }
                    </Label>
                    <Tooltip
                      content={
                        content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.help_text.at_audience_id
                      }
                      class_name="-right-8 top-1/2"
                    />
                  </div>
                  {errors.at_audience_id && touched.at_audience_id ? (
                    <p className="mt-2 text-sm text-red-5">{errors.at_audience_id}</p>
                  ) : null}
                </div>

                <div className="mb-6">
                  <div className="relative">
                    <Field
                      type="text"
                      id="at_audience_name"
                      name="at_audience_name"
                      class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                      placeholder=" "
                    />
                    <Label labelFor="at_audience_name">
                      {
                        content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.formLabels
                          .at_audience_name
                      }
                    </Label>
                    <Tooltip
                      content={
                        content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.help_text
                          .at_audience_name
                      }
                      class_name="-right-8 top-1/2"
                    />
                  </div>
                  {errors.at_audience_name && touched.at_audience_name ? (
                    <p className="mt-2 text-sm text-red-5">
                      {errors.at_audience_name}
                    </p>
                  ) : null}
                </div>

                <div className="mb-6">
                  <div className="relative">
                    <Field
                      type="text"
                      id="at_audience_workspace"
                      name="at_audience_workspace"
                      class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                      placeholder=" "
                    />
                    <Label labelFor="at_audience_workspace">
                      {
                        content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.formLabels
                          .at_audience_workspace
                      }
                    </Label>
                    <Tooltip
                      content={
                        content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.help_text
                          .at_audience_workspace
                      }
                      class_name="-right-8 top-1/2"
                    />
                  </div>
                  {errors.at_audience_workspace && touched.at_audience_workspace ? (
                    <p className="mt-2 text-sm text-red-5">{errors.at_audience_workspace}</p>
                  ) : null}
                </div>

                {showError && (
                  <p className="mt-2 text-sm text-red-5">{showError}</p>
                )}

                <PrimaryButton type="submit">
                  {content.CREATE_NEW_TEALIUM_AUDIENCE_STREAM.submit_cta}
                </PrimaryButton>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default NewTealiumAudienceStream;
